const CompanyStatuses = {
    0: {
        type: 'active',
        displayedName: 'OK',
    },
    2: {
        type: 'processing',
        displayedName: 'Pending',
        toolTip: 'Pending Access',
    },
    3: {
        type: 'processing',
        displayedName: 'Pending',
        toolTip: 'Company awaiting approval',
    },
    4: {
        type: 'processing',
        displayedName: 'Awaiting',
        toolTip: 'Awaiting Initial Pairing',
    },
    5: {
        type: 'processing',
        displayedName: 'Processing',
        toolTip: 'Processing Sync Request',
    },
    10: {
        type: 'processing',
        displayedName: 'Preparing DNS',
        toolTip: 'DNS configuration in progress',
    },
    11: {
        type: 'processing',
        displayedName: 'Provisioning',
        toolTip: 'SBC Provisioning',
    },
    12: {
        type: 'processing',
        displayedName: 'Activating',
        toolTip: 'Activating Teams Calling',
    },
    13: {
        type: 'processing',
        displayedName: 'Provisioning',
        toolTip: 'Teams Calling Provisioning',
    },
    20: {
        type: 'inactive',
        displayedName: 'Error',
        toolTip: 'Pairing Error',
    },
};

export default CompanyStatuses;
